import { compress, compressAccurately } from "image-conversion";
export default {
  data() {
    return {
      url: "https://www.atropin.cn/api/upload/image",
      headers: {
        "Authori-zation": "Bearer " + sessionStorage.getItem("token")
      },
      uploadList: [],
      imgName: "",
      visible: false
    };
  },
  methods: {
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isLt2M = file.size / 1024 / 1024 < 1; // 判定图片大小是否小于1MB
        if (isLt2M) {
          resolve(file);
        }
        // 压缩到400KB,这里的400就是要压缩的大小,可自定义
        compressAccurately(file, 1024)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    handleSuccess(response, file, fileList) {
      this.uploadList = fileList;
    },
    handleView(item) {
      console.log(item)
      //this.imgName = item.response.data.url;
      //this.visible = true;
    },
    handleRemove(index) {
      this.uploadList.splice(index, 1);
    }
  }
};
